import {MutationTree} from 'vuex';
import {Service, ServiceInitState} from '@/store/service/service.types';

export const ServiceMutations: MutationTree<ServiceInitState> = {
  ['mutationGetService'](state: ServiceInitState, payload: Service[]) {
    state.service = payload;
  }
};
